import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Collapse, Divider } from '@mui/material';
import { useState } from 'react';

/** A drawer section that starts closed. */
const TaskFold = ({ label, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Divider sx={{ mt: 2, mb: 0.5 }} />
            <Button
                size="small"
                color="inherit"
                onClick={() => setOpen((o) => !o)}
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                aria-expanded={open}
                sx={{ typography: 'overline', px: 0 }}
            >
                {label}
            </Button>
            <Collapse in={open} unmountOnExit>
                {children}
            </Collapse>
        </>
    );
};

export default TaskFold;
